export default __webpack_public_path__ + "static/media/pyton.af527a1f.PNG";